import React from "react";
import {
  Input,
  FormControl,
  FormLabel,
  InputGroup,
  InputLeftElement,
  FormErrorMessage,
  Icon,
} from "@chakra-ui/react";
import { FiFile } from "react-icons/fi";
import { Controller, useController, useForm } from "react-hook-form";
import { useRef } from "react";

export const HookFilePicker = ({
  inputName,
  placeholder,
  label,
  acceptedFileTypes,
  required,
  variant,
  ml,
  mb,
  control,
  errors,
  multiple = false
}) => {
  const componentRef = useRef(null);

  const otherProps = {};

  if (variant) {
    otherProps.variant = variant;
  }

  return (
    <Controller
      control={control}
      name={inputName}
      rules={{ required }}
      render={({ field: { onChange, onBlur, value, name, ref } }) => (
        <FormControl
          isInvalid={errors[inputName]}
          isRequired={required}
          mb={mb ? mb : '5'}
          ml={ml ? ml : '3'}
        >
          <FormLabel fontSize="md" color="white" htmlFor={name}>
            {label}
          </FormLabel>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Icon as={FiFile} />
            </InputLeftElement>
            <input
              type="file"
              multiple={multiple}
              accept={acceptedFileTypes}
              name={name}
              style={{ opacity: "0", height: 1, width: 1, backgroundColor: "#2D3748"}}
              onChange={(e) => {
                if (e.target?.files?.length > 0) {
                  const files = multiple ? Array.from(e.target.files) : e.target.files[0];
                  onChange(files);
                }
              }}
              onBlur={onBlur}
              ref={(e) => {
                ref(e);
                componentRef.current = e; // you can still assign to ref
              }}
            />
            <Input
              placeholder={placeholder || "Your file ..."}
              onClick={() => componentRef.current.click()}
              onChange={() => {}}
              readOnly={true}
              value={
                value
                  ? multiple
                    ? value.map((f) => f.name).join(', ')
                    : value.name
                  : ''
              }
              variant={variant}
            />
          </InputGroup>
          <FormErrorMessage>
            {errors[inputName] && "This field is required"}
          </FormErrorMessage>
        </FormControl>
      )}
    />
  );
};

const FileUpload = ({
  name,
  placeholder,
  acceptedFileTypes,
  control,
  children,
  isRequired = false,
  setParentValue,
}) => {
  const inputRef = useRef();
  const {
    field: { ref, onChange, value, ...inputProps },
    fieldState: { invalid },
  } = useController({
    name,
    control,
    rules: { required: isRequired },
  });

  const onValueChange = (e) => {
    if (e.target?.files?.length > 0) {
      onChange(e.target.files[0]);
      if (setParentValue) {
        setParentValue(e.target.files[0]);
      }
    }
  };

  return (
    <FormControl isInvalid={invalid}>
      <FormLabel htmlFor="writeUpFile">{children}</FormLabel>
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <Icon as={FiFile} />
        </InputLeftElement>
        <input
          type="file"
          onChange={onValueChange}
          accept={acceptedFileTypes}
          name={name}
          ref={inputRef}
          {...inputProps}
          style={{ display: "none" }}
        />
        <Input
          placeholder={placeholder || "Your file ..."}
          onClick={() => inputRef.current.click()}
          readOnly={true}
          value={(value && value.name) || ""}
        />
      </InputGroup>
      <FormErrorMessage>{invalid}</FormErrorMessage>
    </FormControl>
  );
};

FileUpload.defaultProps = {
  acceptedFileTypes: "",
  allowMultipleFiles: false,
};

export function ImageFilePicker({ name, setImageValue }) {
  const { control } = useForm();

  return (
    <FileUpload
      setParentValue={setImageValue}
      name={name}
      placeholder="Upload File"
      control={control}
      acceptedFileTypes={"image/*"}

    />
  );
}

export function CSVFilePicker({ name, setCSVValue }) {
  const { control } = useForm();

  return (
    <FileUpload
      setParentValue={setCSVValue}
      name={name}
      placeholder="Upload CSV File"
      control={control}
      acceptedFileTypes={".csv"}
    />
  );
}

export function ResumeFilePicker({ name, setResumeValue }) {
  const { control } = useForm();

  return (
    <FileUpload
      setParentValue={setResumeValue}
      name={name}
      placeholder="Upload Resume File"
      control={control}
    />
  );
}
